import { render, staticRenderFns } from "./pexpertList.vue?vue&type=template&id=031d3963&scoped=true"
import script from "./pexpertList.vue?vue&type=script&lang=js"
export * from "./pexpertList.vue?vue&type=script&lang=js"
import style0 from "./pexpertList.vue?vue&type=style&index=0&id=031d3963&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031d3963",
  null
  
)

export default component.exports